import React, { useEffect, useState } from "react";
import { Global } from "../helpers/Global";

export const PlantillaTurnoAdmin = () => {
  const [plantillas, setPlantillas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [mensaje, setMensaje] = useState("");
  const [modal, setModal] = useState({ open: false, plantilla: null, editData: null });

  useEffect(() => {
    cargarPlantillas();
    // eslint-disable-next-line
  }, []);

  const cargarPlantillas = async () => {
    setLoading(true);
    try {
      const res = await fetch(Global.url + "turnos/plantillas", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      const data = await res.json();
      setPlantillas(data);
    } catch {
      setMensaje("Error al cargar plantillas");
    }
    setLoading(false);
  };

  // Eliminar (borrado suave)
  const eliminarPlantilla = async (id) => {
    if (!window.confirm("¿Eliminar esta plantilla?")) return;
    setLoading(true);
    try {
      const res = await fetch(Global.url + `turnos/plantillas/${id}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      if (res.ok) {
        setMensaje("Plantilla eliminada.");
        cargarPlantillas();
      } else {
        setMensaje("No se pudo eliminar la plantilla.");
      }
    } catch {
      setMensaje("Error de conexión.");
    }
    setLoading(false);
  };

  // Abrir modal de edición
  const abrirModalEdicion = (plantilla) => {
    setModal({
      open: true,
      plantilla,
      editData: {
        nombre: plantilla.nombre,
        descripcion: plantilla.descripcion || "",
        color: plantilla.color || "#85C1E9",
        segmentos: Array.isArray(plantilla.segmentos)
          ? plantilla.segmentos
          : JSON.parse(plantilla.segmentos || "[]"),
      }
    });
  };

  // Guardar edición
  const guardarEdicion = async () => {
    setLoading(true);
    setMensaje("");
    try {
      const res = await fetch(Global.url + `turnos/plantillas/${modal.plantilla.id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({
          nombre: modal.editData.nombre,
          descripcion: modal.editData.descripcion,
          color: modal.editData.color,
          segmentos: modal.editData.segmentos,
        }),
      });
      if (res.ok) {
        setMensaje("Plantilla actualizada correctamente.");
        setModal({ open: false, plantilla: null, editData: null });
        cargarPlantillas();
      } else {
        setMensaje("No se pudo actualizar la plantilla.");
      }
    } catch {
      setMensaje("Error de conexión.");
    }
    setLoading(false);
  };

  // Cambiar datos en edición
  const handleEditChange = (campo, valor) => {
    setModal((prev) => ({
      ...prev,
      editData: {
        ...prev.editData,
        [campo]: valor,
      }
    }));
  };

  // Editar un segmento horario
  const handleSegmentoEdit = (idx, campo, valor) => {
    setModal((prev) => ({
      ...prev,
      editData: {
        ...prev.editData,
        segmentos: prev.editData.segmentos.map((seg, i) =>
          i === idx ? { ...seg, [campo]: valor } : seg
        ),
      }
    }));
  };

  // Añadir/quitar segmentos en edición
  const agregarSegmento = () => {
    setModal((prev) => ({
      ...prev,
      editData: {
        ...prev.editData,
        segmentos: [...prev.editData.segmentos, { hora_inicio: "", hora_fin: "" }],
      }
    }));
  };
  const eliminarSegmento = (idx) => {
    if (modal.editData.segmentos.length === 1) return;
    setModal((prev) => ({
      ...prev,
      editData: {
        ...prev.editData,
        segmentos: prev.editData.segmentos.filter((_, i) => i !== idx),
      }
    }));
  };

  const cerrarModal = () => {
    setModal({ open: false, plantilla: null, editData: null });
  };

  return (
    <div style={{ maxWidth: 700, margin: "auto" }}>
      <h2>Plantillas de turno</h2>
      {loading && <p>Cargando...</p>}
      {mensaje && <p style={{ color: mensaje.startsWith("Plantilla") ? "green" : "red" }}>{mensaje}</p>}
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Descripción</th>
            <th>Color</th>
            <th>Segmentos</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {plantillas.length === 0 && (
            <tr>
              <td colSpan={5}>No hay plantillas registradas.</td>
            </tr>
          )}
          {plantillas.map((p) => (
            <tr key={p.id}>
              <td>{p.nombre}</td>
              <td>{p.descripcion}</td>
              <td>
                <span style={{
                  display: "inline-block",
                  background: p.color || "#eee",
                  width: 24,
                  height: 24,
                  borderRadius: 5,
                  border: "1px solid #bbb"
                }} title={p.color}></span>
              </td>
              <td>
                {(Array.isArray(p.segmentos) ? p.segmentos : JSON.parse(p.segmentos || "[]"))
                  .map((seg, i) =>
                    <span key={i} style={{ marginRight: 7 }}>
                      {seg.hora_inicio} - {seg.hora_fin}
                    </span>
                  )
                }
              </td>
              <td>
                <button onClick={() => abrirModalEdicion(p)} disabled={modal.open}>Editar</button>
                <button onClick={() => eliminarPlantilla(p.id)} style={{ marginLeft: 7 }} disabled={modal.open}>Eliminar</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {modal.open && (
        <div className="turnos-modal-backdrop">
          <div className="turnos-modal">
            <h3>Editar plantilla</h3>
            <form onSubmit={e => { e.preventDefault(); guardarEdicion(); }}>
              <label>
                Nombre:<br />
                <input value={modal.editData.nombre} onChange={e => handleEditChange("nombre", e.target.value)} required />
              </label>
              <label>
                Descripción:<br />
                <input value={modal.editData.descripcion} onChange={e => handleEditChange("descripcion", e.target.value)} />
              </label>
              <label>
                Color:<br />
                <input type="color" value={modal.editData.color} onChange={e => handleEditChange("color", e.target.value)} />
              </label>
              <div style={{ margin: "1em 0" }}>
                <b>Segmentos (horarios):</b>
                {modal.editData.segmentos.map((seg, i) => (
                  <div key={i} style={{ marginBottom: 8, display: "flex", gap: 8, alignItems: "center" }}>
                    <input
                      type="time"
                      value={seg.hora_inicio}
                      onChange={e => handleSegmentoEdit(i, "hora_inicio", e.target.value)}
                      required
                    />
                    <span>a</span>
                    <input
                      type="time"
                      value={seg.hora_fin}
                      onChange={e => handleSegmentoEdit(i, "hora_fin", e.target.value)}
                      required
                    />
                    {modal.editData.segmentos.length > 1 && (
                      <button type="button" onClick={() => eliminarSegmento(i)} style={{ marginLeft: 6 }}>
                        ❌
                      </button>
                    )}
                  </div>
                ))}
                <button type="button" onClick={agregarSegmento} style={{ marginTop: 6 }}>+ Añadir segmento</button>
              </div>
              <div style={{ marginTop: 18 }}>
                <button type="submit" disabled={loading}>Guardar</button>
                <button type="button" onClick={cerrarModal} style={{ marginLeft: 8 }}>Cancelar</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};
